<template>
  <v-data-table
    :headers="headers"
    :items="requests"
    :loading="loading"
    sort-by="requestSubmittedAt"
    sort-desc
  >
    <template v-slot:[`item.actions`]="{ item }">
      <view-request-action v-if="!item.pending" :request="item"></view-request-action>
      <edit-request-action v-if="item.pending" :request="item">
      </edit-request-action>
      <approve-deny-action
        v-if="item.pending"
        :request="item"
      ></approve-deny-action>
    </template>
  </v-data-table>
</template>
<script>
import ViewRequestAction from "./view-request-action.vue"
import EditRequestAction from "./edit-request-action.vue";
import ApproveDenyAction from "./approve-deny-action.vue";
export default {
  props: ["loading"],
  components: {
    ViewRequestAction,
    EditRequestAction,
    ApproveDenyAction,
  },
  data() {
    return {
      headers: [
        { text: "Request ID", value: "paidSickLeaveRequestId", align: "left" },
        { text: "Provider", value: "providerName" },
        { text: "Start Date", value: "formattedStartDate" },
        { text: "End Date", value: "formattedEndDate" },
        { text: "Total Hours", value: "hoursRequested" },
        { text: "Reason", value: "reason" },
        { text: "Date Submitted", value: "formattedSubmittedDate" },
        { text: "Status", value: "status" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    requests() {
      return this.$store.state.paidSickLeaveModule.requests || [];
    },
  },
};
</script>